import { getFunctionSigHash } from '../utils/getFunctionSigHash';
export async function updateSpaceInfo(params) {
    const { spaceDapp, smartAccount, fnArgs } = params;
    if (!spaceDapp) {
        throw new Error('spaceDapp is required');
    }
    const { spaceId, name, uri, shortDescription, longDescription, signer } = fnArgs;
    // the function name in the contract is updateSpaceInfo
    // in space dapp we update the space name only using updateSpaceInfo which calls updateSpaceInfo
    const functionName = 'updateSpaceInfo';
    const functionHashForPaymasterProxy = getFunctionSigHash(spaceDapp.spaceOwner.interface, functionName);
    const spaceInfo = await spaceDapp.getSpaceInfo(spaceId);
    if (!spaceInfo) {
        throw new Error(`Space with id "${spaceId}" is not found.`);
    }
    return spaceDapp.spaceOwner.updateSpaceInfo({
        spaceId,
        name,
        uri: uri ?? spaceInfo.uri ?? '',
        shortDescription: shortDescription ?? spaceInfo.shortDescription ?? '',
        longDescription: longDescription ?? spaceInfo.longDescription ?? '',
        signer,
        overrideExecution: async ({ calldata }) => {
            return smartAccount.sendUserOp({
                toAddress: spaceDapp.spaceOwner.address,
                callData: calldata,
                spaceId: spaceId,
                signer,
                functionHashForPaymasterProxy,
            });
        },
    });
}
